/**
 * Every piece of UI that requires javascript should have its own
 * javascript file. Use this file as a template for structuring
 * all JS source files.
 *
 * Layout Block Slider
 *
 * Initialize and define behavior of the block slider
 * Uses the Slick Slides jQuery plugin --> http://kenwheeler.github.io/slick/
 */

const $         = require( 'jQuery' );
const _model    = require( '../utilities/_model.js' );
const throttled = require( '../_debounce.js' );

var LayoutSlider = function(el){

  this.$el            = $(el);
  this.globalDefaults = {
    slidesToScroll  : 1,
    autoplaySpeed   : 5000,
    pauseOnDotsHover: true,
    dots            : true,
    arrows          : false,
    pauseOnHover    : true
  };

  this.init();
};

LayoutSlider.prototype.init = function(){
  var data = this.$el.attr('data-slick'),
    options =  ! _model.empty( data ) ? JSON.parse( data ) : {},
    that = this,
    slickResize;

  //Init the slider
  options = $.extend( this.globalDefaults, options );

  this.carousel = this.$el.slick( options );

  this.carousel.on('beforeChange', function(event, slick, currentSlide, nextSlide){
    that.$el.find('.slick-slide').removeClass('itbl-has-past');
    that.$el.find('.slick-slide[data-slick-index="'+nextSlide+'"]').prevAll().addClass('itbl-has-past');
  });

  $(document).one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function(){
    that.carousel.slick('setPosition');
  });

  $(window).on('resize orientationchange', throttled( 250, function(){

    var slick = $(that.carousel)[0].slick;
    slick.refresh();

  } ));

};

LayoutSlider.prototype.onAllImagesLoaded = function (cb) {
  var $images = this.$el.find('img');
  var leftToLoad = $images.length;

  var onImageVisible = function () {
    leftToLoad--;
    if (leftToLoad === 0 && cb) cb();
  };

  if (leftToLoad === 0) {
    onImageVisible();
    return;
  }

  $images.on('load', onImageVisible).each(function() { if(this.complete) $(this).load(); });
  $images.on('error', onImageVisible);
};

$(document).ready(function(){
  $('.js-layout-slider').each(function(){
    new LayoutSlider( this );
  });

});

// Initialize dynamic block preview (editor).
if( window.acf ) {

  //addAction for full width Slider
  window.acf.addAction( 'render_block_preview/type=full-width-slider', function( el, props ){

    $(el).find('.js-layout-slider').each(function(){
      new LayoutSlider( this );
    });
  } );

  //addAction for Customer Slider
  window.acf.addAction( 'render_block_preview/type=customer-slider', function( el, props ){

    $(el).find('.js-layout-slider').each(function(){
      new LayoutSlider( this );
    });
  } );

  //addAction for Resources Slider
  window.acf.addAction( 'render_block_preview/type=itbl-post-cards', function( el, props ){

    $(el).find('.js-layout-slider').each(function(){
      new LayoutSlider( this );
    });
  } );
  
}
